export const sizeOrder = {
  XXS: 0,
  XS: 1,
  S: 2,
  M: 3,
  L: 4,
  XL: 5,
  XXL: 6,
  '3XL': 7,
  '4XL': 8,
  //***** */
  '0': 16,
  '1': 17,
  '1.5': 18,
  '2': 19,
  '2.5': 20,
  '3': 21,
  '3.5': 22,
  '4': 23,
  '4.5': 24,
  '5': 25,
  '5.5': 26,
  '6': 27,
  '6.5': 28,
  '7': 29,
  '7.5': 30,
  '8': 31,
  '8.5': 32,
  '9': 33,
  '9.5': 34,
  '10': 35,
  '10.5': 36,
  '11': 37,
  '11.5': 38,
  '12': 39,
  '12.5': 40,
  '13': 41,
  '13.5': 42,
  '14': 43,
  '14.5': 44,
  '15': 45,
  //***** */
  '24': 53,
  '25': 53.5,
  '26': 54,
  '27': 54.5,
  '28': 55,
  '29': 55.5,
  '30': 56,
  '31': 56.5,
  '32': 57,
  '33': 57.5,
  '34': 58,
  '35': 58.5,
  '36': 59,
  '37': 59.5,
  '38': 60,
  '39': 60.5,
  '40': 61,
  '41': 61.5,
  '42': 62,
  '43': 62.5,
  '44': 63,
  '45': 63.5,
  '46': 64,
  '47': 64.5,
  '48': 65,
  '49': 65.5,
  '50': 66,
  '51': 66.5,
  '52': 67,
  '53': 67.5,
  '54': 68,
  '55': 68.5,
  '56': 69,
  '57': 69.5,
  '58': 70,
  '59': 70.5,
  '60': 71,
  //***** */
  '80': 82,
  '90': 83,
  '100': 84,
  '110': 85,
  '120': 86,
  '130': 87,
  '140': 88,
  '150': 89,
  //***** */
  '6M': 100,
  '12M': 101,
  //***** */
  '1YR': 109,
  '2YR': 110,
  '3YR': 111,
  '4YR': 112,
  '5YR': 113,
  '6YR': 114,
  '7YR': 115,
  '8YR': 116,
  '9YR': 117,
  '10YR': 118,
  '11YR': 119,
  '12YR': 120,
  '13YR': 121,
  '14YR': 122,
  '15YR': 123,
  '16YR': 124,
  '17YR': 125,
};
